import { CurrencyCode } from "@smartrr/shared/currencyCode";
import { PresentmentPrice } from "@smartrr/shared/entities/PurchasableVariant";
import { formatMoney, removeTrailingZeros, unformatMoney } from "@smartrr/shared/utils/formatMoney";

export interface IGetPrice {
  initial: PresentmentPrice;
  current: PresentmentPrice;
}

export const defaultGetPrice = (currency: CurrencyCode) => {
  return {
    current: {
      price: 0,
      priceCurrency: currency,
    },
    initial: {
      price: 0,
      priceCurrency: currency,
    },
  } as IGetPrice;
};

export interface IFormatGetPriceOptions {
  removeTrailingZeros: boolean;
}

export const formatGetPrice = (prices: IGetPrice, currency: CurrencyCode, options?: IFormatGetPriceOptions) => {
  const fmt = (presentment: PresentmentPrice) => {
    const price = Math.max(0, presentment.price);

    let formattedPrice = formatMoney(unformatMoney(price, currency), currency);
    const shouldRemoveTrailingZeros = options && options.removeTrailingZeros;
    formattedPrice = shouldRemoveTrailingZeros ? removeTrailingZeros(formattedPrice) : formattedPrice;

    return formattedPrice;
  };

  return {
    initial: fmt(prices.initial),
    current: fmt(prices.current),
  };
};

export const formatBasicPrice = (presentment: PresentmentPrice, options?: IFormatGetPriceOptions) => {
  const price = Math.max(0, presentment.price);

  let formattedPrice = formatMoney(unformatMoney(price, presentment.priceCurrency), presentment.priceCurrency);
  const shouldRemoveTrailingZeros = options && options.removeTrailingZeros;
  formattedPrice = shouldRemoveTrailingZeros ? removeTrailingZeros(formattedPrice) : formattedPrice;

  return formattedPrice;
};
